import { useCallback, useMemo } from 'react';
import { useInstance } from '@milkdown/react';
import { wrapInHeadingCommand } from '@milkdown/preset-commonmark';
import { createClickFunction } from '../../util/notes';
import { useNotesToolbarContext } from '../../context/notes/notes_toolbar_context';
import { headingFormatOptions, } from '../../types/notes/text_heading_dropdown';
import { useEditorStateContext } from '../../context/notes/notes_editor_state_context';
export function useTextHeadingDropdown() {
    const [isLoading, getEditorInstance] = useInstance();
    const { textHeadingDropdownContext } = useNotesToolbarContext();
    const { captureButtonClick, inCallOrPostCall, displayModeYn, readOnlyYn } = useEditorStateContext();
    const selectedOption = headingFormatOptions[0];
    const isDropdownDisabled = displayModeYn || readOnlyYn || textHeadingDropdownContext.disableTextHeadingDropdownYn;
    const onSelectOption = useCallback((selectedOption) => {
        if (!isLoading) {
            textHeadingDropdownContext.selectActiveHeadingOption(selectedOption);
            const headingOptionClickFunction = createClickFunction(getEditorInstance, isLoading, wrapInHeadingCommand.key, selectedOption.value.commandOption);
            headingOptionClickFunction();
            typeof captureButtonClick === 'function' &&
                captureButtonClick(`${inCallOrPostCall}-${selectedOption.value.analyticsId}`);
        }
    }, [
        isLoading,
        textHeadingDropdownContext,
        getEditorInstance,
        captureButtonClick,
        inCallOrPostCall,
    ]);
    return useMemo(() => {
        return {
            headingFormatOptions,
            isLoading,
            selectedOption,
            onSelectOption,
            isDropdownDisabled,
        };
    }, [isLoading, selectedOption, onSelectOption, isDropdownDisabled]);
}
//# sourceMappingURL=use_text_heading_dropdown.js.map